const HoldingBackground = () => (
  <div className="absolute top-0 left-0 w-full h-full">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1280 800"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M76.4744 209.514L79.7515 217.625L92.5003 212.474L89.2232 204.363L112.403 195L115.68 203.111L128.428 197.96L125.151 189.849L148.332 180.486L151.609 188.597L157.404 186.257L176.134 232.61L69.5084 275.683L50.7776 229.33L56.5725 226.989L53.2954 218.878L76.4744 209.514Z"
        fill="#FFD500"
      />
      <path
        d="M435.455 183.973L426.837 182.454L424.666 194.762L433.284 196.282L428.943 220.898L420.326 219.378L419.24 225.533L370 216.852L383.024 143.001L432.264 151.683L431.178 157.837L439.796 159.356L435.455 183.973Z"
        fill="#004A80"
      />
      <path
        d="M750.004 43.1345L747.734 38.6812L792.284 15.9852L861.518 151.844L816.967 174.54L814.129 168.972L806.333 172.944L794.984 150.672L802.779 146.7L796.537 134.451L788.742 138.423L777.392 116.151L785.188 112.179L778.945 99.9287L771.149 103.901L759.799 81.629L767.596 77.6566L761.353 65.4075L753.557 69.3799L742.207 47.1069L750.004 43.1345Z"
        fill="#00963E"
      />
      <path
        d="M1072.41 30.5612L1086.03 28.6476L1084.81 19.9847L1109.57 16.5053L1110.79 25.1682L1124.4 23.2546L1123.19 14.5917L1147.94 11.1133L1149.16 19.7762L1155.35 18.9074L1162.31 68.4139L1048.43 84.4157L1041.47 34.9102L1047.66 34.0405L1046.44 25.3766L1071.2 21.8973L1072.41 30.5612Z"
        fill="#004A80"
      />
      <path
        d="M107.998 438.971L103.756 431.319L92.8227 437.379L97.0648 445.031L75.1992 457.15L70.9576 449.497L65.4912 452.528L41.2497 408.803L106.847 372.447L131.087 416.172L125.621 419.2L129.863 426.853L107.998 438.971Z"
        fill="#E3000B"
      />
      <path
        d="M312.931 793.475L318.257 800.415L329.165 792.044L323.839 785.104L343.672 769.883L348.998 776.823L359.906 768.452L354.58 761.513L374.413 746.293L379.739 753.233L390.647 744.862L385.321 737.922L405.155 722.702L410.481 729.642L414.448 726.599L444.885 766.258L323.903 859.1L293.466 819.44L298.424 815.635L293.097 808.694L312.931 793.475Z"
        fill="#00963E"
      />
      <path
        d="M672.826 638.208L669.689 630.04L656.852 634.967L659.989 643.134L636.649 652.092L633.513 643.925L620.676 648.851L623.813 657.02L600.473 665.977L597.337 657.809L591.502 660.049L573.584 613.376L680.945 572.17L698.864 618.843L693.029 621.082L696.165 629.25L672.826 638.208Z"
        fill="#00963E"
      />
      <path
        d="M906.502 259.216L911.138 266.636L922.798 259.35L918.162 251.931L939.364 238.685L943.999 246.104L955.661 238.818L951.024 231.399L972.226 218.153L976.861 225.572L988.522 218.287L983.886 210.868L1005.09 197.622L1009.72 205.041L1013.96 202.391L1040.46 244.788L911.133 325.589L884.637 283.193L889.937 279.881L885.3 272.462L906.502 259.216Z"
        fill="#EE7500"
      />
      <path
        d="M1290.16 286.676L1291.86 291.378L1244.84 308.371L1193 164.973L1240.02 147.979L1242.15 153.855L1250.38 150.882L1258.87 174.39L1250.64 177.364L1255.32 190.293L1263.55 187.319L1272.05 210.827L1263.82 213.801L1268.49 226.731L1276.72 223.756L1285.22 247.265L1276.99 250.238L1281.66 263.168L1289.89 260.194L1298.39 283.702L1290.16 286.676Z"
        fill="#AFCA00"
      />
      <path
        d="M1125.86 528.12L1119.99 525.984L1137.09 479.005L1245.16 518.332L1228.06 565.31L1222.18 563.172L1219.19 571.394L1195.7 562.845L1198.69 554.623L1185.77 549.92L1182.78 558.142L1159.29 549.593L1162.28 541.372L1149.36 536.669L1146.36 544.891L1122.87 536.342L1125.86 528.12Z"
        fill="#F5B4D2"
      />
      <path
        d="M-51.9075 584.589L-55.5642 581.18L-21.4641 544.618L90.0675 648.608L55.9674 685.17L51.3964 680.908L45.4289 687.307L27.1459 670.259L33.1127 663.861L23.0559 654.484L17.0891 660.883L-1.19467 643.835L4.77282 637.436L-5.28325 628.06L-11.2507 634.459L-29.5345 617.412L-23.567 611.013L-33.6231 601.637L-39.5905 608.036L-57.875 590.988L-51.9075 584.589Z"
        fill="#00963E"
      />
      <path
        d="M180.698 687.969L188.562 691.805L194.589 679.447L186.726 675.613L197.686 653.147L205.549 656.981L211.576 644.624L203.712 640.79L214.673 618.323L222.535 622.158L228.563 609.801L220.7 605.967L231.659 583.5L239.523 587.334L241.715 582.842L286.655 604.757L219.804 741.804L174.864 719.888L177.603 714.271L169.739 710.436L180.698 687.969Z"
        fill="#0098D2"
      />
      <path
        d="M980.63 632.67L976.255 625.093L964.348 631.967L968.723 639.543L947.073 652.042L942.697 644.465L930.788 651.339L935.164 658.916L913.514 671.414L909.138 663.838L897.231 670.711L901.606 678.288L879.955 690.787L875.58 683.21L871.25 685.71L846.25 642.414L978.319 566.176L1003.32 609.47L997.906 612.594L1002.28 620.172L980.63 632.67Z"
        fill="#FFD500"
      />
      <path
        d="M1173.63 717.325L1179.01 724.22L1183.94 720.373L1214.72 759.767L1185.17 782.852L1154.39 743.456L1159.31 739.609L1153.93 732.714L1173.63 717.325Z"
        fill="#2CAFE5"
      />
      <path
        d="M350.366 68.4863L345.428 61.2638L340.269 64.7901L312.055 23.5174L343.014 2.35877L371.228 43.632L366.068 47.158L371.006 54.3812L350.366 68.4863Z"
        fill="#EE7500"
      />
      <path
        d="M641.168 750.38L637.495 745.324L677.946 715.94L722.03 776.607L681.579 805.992L677.904 800.937L670.826 806.079L656.131 785.856L663.209 780.714L655.862 770.603L648.785 775.745L634.09 755.523L641.168 750.38Z"
        fill="#FFD500"
      />
      <path
        d="M914.499 778.03L911.004 772.849L952.456 744.895L994.395 807.063L952.944 835.019L949.448 829.838L942.195 834.73L928.215 814.007L935.468 809.115L928.478 798.754L921.225 803.646L907.245 782.923L914.499 778.03Z"
        fill="#004A80"
      />
    </svg>
  </div>
);

export default HoldingBackground;
